// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBm9aG473zIt2rfDQa_fqFcXttwSJduQBg",
    authDomain: "revista-cultivar.firebaseapp.com",
    projectId: "revista-cultivar",
    storageBucket: "revista-cultivar.appspot.com",
    messagingSenderId: "1057827166343",
    appId: "1:1057827166343:web:9a8486d7622c915aca8022"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
